import React, { useContext, useState, useEffect, useRef } from 'react';
import EditText from '../crm/shared/field_inputs/text/EditText';
import EditDate from '../crm/shared/field_inputs/date/EditDate';
import { DataContext as ExlDataContext } from '../../stores/exl-store';
import {HandleUpdateCertificate } from './requests/CertificateRequests';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ExlFormModal from './shared/ExlFormModal';
import moment from "moment";
import { useTranslation } from 'react-i18next';
import EditSelectMany from '../crm/shared/field_inputs/select_many/EditSelectMany';
import { CERTIFICATE_MODALS_EDIT_CERTIFICATE_LABEL, CERTIFICATE_MODALS_INVALID_DATE_VALI, CERTIFICATE_MODALS_NAME_LABEL, CERTIFICATE_MODALS_DATE_LABEL, CERTIFICATE_MODALS_TAGS_LABEL, CERTIFICATE_MODALS_NO_NAME_VALI, CERTIFICATE_MODALS_TO_LONG_NAME_VALI, EMAIL_NOTIFICATIONS_FALSE, EMAIL_NOTIFICATIONS_TRUE, LECTURE_MODALS_INVALID_TIME_VALI } from '../../i18n/keyConstants';

const EditCertificate = ({ certificate, open, onClose}) => {
    let defaultFormValues = {
        ...certificate,
        name: certificate.name,
        certificateDate: certificate.certificateDate
    }
    const { t } = useTranslation(['certificateModals', 'addCertificate']);

    const [defaultTemplate, setDefaultTemplate] = useState(defaultFormValues);

    let label = t(CERTIFICATE_MODALS_EDIT_CERTIFICATE_LABEL);

    const clearForm = () => {
        defaultFormValues = {
            ...certificate,
            name: certificate.name,
            certificateDate: certificate.certificateDate
        }
        setDefaultTemplate(defaultFormValues);
    }

    const { store: exlStore } = useContext(ExlDataContext);
    const tags = exlStore.certificateTags;
    
    const formComponents = [
       {
            propName: 'name',
            label: t(CERTIFICATE_MODALS_NAME_LABEL),
            validate: (v) => (!v || !v.length ? t(CERTIFICATE_MODALS_NO_NAME_VALI) : v.length > 60 ? t(CERTIFICATE_MODALS_TO_LONG_NAME_VALI) : ''),
            component: <EditText />,
        },
        {
            propName: 'certificateDate',
            label: t(CERTIFICATE_MODALS_DATE_LABEL),
            validate: (v) => (!v ? t(CERTIFICATE_MODALS_INVALID_DATE_VALI) : ''),
            component: <EditDate/>,
        },
        {
            propName: 'tags',
            label: t(CERTIFICATE_MODALS_TAGS_LABEL),
            validate: () => true,
            // component: <EditSelectMany values={[{ id: 1, name: 'test' }]} />,
            // component: <SelectManyInputContainer iconName='place' options={store.SkillOptions} />,
            component: (
                <EditSelectMany
                    label={t(CERTIFICATE_MODALS_TAGS_LABEL)}
                    icon='place'
                    initialValue={[]}
                    options={tags}
                    handleSave={(a, b, c) => console.log('hs-edit', { a, b, c })}
                />
            ),
        },
    ];

    const handleUpdate = async (certificate) => {
        const response = await HandleUpdateCertificate(certificate, {
            ...certificate,
            id: certificate.id,
            modifiedDate: moment.utc()
        });
        return response;
    };

    return (
        <ExlFormModal
            open={open}
            onClose={onClose}
            description={t(CERTIFICATE_MODALS_EDIT_CERTIFICATE_LABEL)}
            defaultFormValues={defaultTemplate}
            defaultFormComponents={formComponents}
            handleAdd={handleUpdate}
            onSuccessiveSave={async () => {
                clearForm();
                window.location.reload();
            }}
            isExl
        />
    );
};
export default EditCertificate;
